import { render, staticRenderFns } from "./DepreciationHistory.vue?vue&type=template&id=512edbd8&scoped=true"
import script from "./DepreciationHistory.vue?vue&type=script&lang=js"
export * from "./DepreciationHistory.vue?vue&type=script&lang=js"
import style0 from "./DepreciationHistory.vue?vue&type=style&index=0&id=512edbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512edbd8",
  null
  
)

export default component.exports